module.exports = __webpack_public_path__ + "img/slide3.53079d45.png";